module.exports = __webpack_public_path__ + "files/28fa2fc4837d70219ed49f4871d499ad.png";